<template>
  <div>
    <el-form-item :label="titulo">
      <span v-if="filePath">
        <a :href="filePath" target="_blank" style="padding-right: 20px">
          <i class="fa fa-file-pdf-o" /> Ver
        </a>
      </span>
      <span v-else>
        <el-tag type="warning">No se encontró</el-tag>
      </span>
      <el-upload
        :v-if="habModificaPdf"
        :id="id"
        class="upload-demo"
        ref="refFile"
        :action="serverURI + 'api/uploadPdfFile'"
        :auto-upload="true"
        accept="application/pdf"
        :on-success="handlePdf"
        :on-exceed="handleExceed"
        :on-remove="handleRemove"
        :show-file-list="false"
        :data="{
          folder: 'altaProveedor',
        }"
        :limit="0"
      >
        <el-button v-if="habModificaPdf" slot="trigger" size="small" type="primary"
          >Seleccionar archivo</el-button
        >
        <el-button v-if="fileName" size="small" enable="false" type="secondary">{{fileName ? fileName + ".pdf" : "-"}}</el-button>
        <el-button v-if="filePath && habModificaPdf" @click="removePdf" size="small" type="primary">X</el-button>
        <div v-if="habModificaPdf && !disabled" slot="tip" class="el-upload__tip">Solo se permiten archivos PDF</div>
      </el-upload>
    </el-form-item>
  </div>
</template>
<script>
import api from '../api'
import config from '../config'
export default {
  data () {
    return {
      serverURI: config.serverURI,
      pFilePath: '',
      pFileName: '',
      pTargetDir: '',
      finalFilePath: '',
      partialPath: '',
      urlUpl: ''
    }
  },
  name: 'PdfFile',
  props: {
    titulo: String,
    id: String,
    prop: String,
    pdfFilePath: String,
    pdfFileName: String,
    habModificaPdf: Boolean,
    country: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  created () {
    this.getUploadPath()
  },
  methods: {
    persisteNewProvider (inputValue, inputName, country = 'ARG') {
      if (country === 'ARG') {
        let newProvider = JSON.parse(localStorage.getItem('newProvider'))
        if (!newProvider) {
          newProvider = {}
        }
        newProvider[inputName] = inputValue
        localStorage.setItem('newProvider', JSON.stringify(newProvider))
      }
      if (country === 'PER') {
        let newProvider = JSON.parse(localStorage.getItem('newProviderPeru'))
        if (!newProvider) {
          newProvider = {}
        }
        newProvider[inputName] = inputValue
        localStorage.setItem('newProviderPeru', JSON.stringify(newProvider))
      }
      //
      // localStorage.setItem(`${inputName}key`, JSON.stringify(inputValue))
    },
    getUploadPath () {
      api.request('get', `api/findConfiguration?attribute=URL-UPL`)
      .then((response) => {
        this.urlUpl = this.validateParams(response.data['value'])
      })
      .catch((error) => {
        console.log(error)
      })
    },
    getDataFromLocalStorage (inputType, inputId) {
      console.log(inputType)
      // const data = localStorage.getItem(`${inputId}key`)
      let newProvider = JSON.parse(localStorage.getItem('newProvider'))
      if (newProvider) {
        const data = newProvider[inputId]
        if (data) {
          inputType[inputId] = data
        }
      }
    },
    handlePdf (response, file, fileList) {
      let param = response
      this.pFilePath = this.validateParams(param.ruta)
      this.pFileName = param.original_file_name
      this.finalFilePath = this.pFilePath + this.pFileName
      this.$emit('update:pdfFilePath', this.pFileName)
      this.persisteNewProvider(this.pFileName, this.prop)
    },
    validateParams (param) {
      if (!param.endsWith('/')) {
        return param + '/'
      }
      return param
    },
    handleRemove (response, file, fileList) {
      let data = new FormData()
      data.append('folder', 'altaProveedor')
      data.append('file', '')
      api.request('POST', 'api/uploadPdfFile', data).then((response) => {
        this.pFilePath = ''
      })
      this.pFilePath = ''
    },
    removePdf (response, file, fileList) {
      // this.generalData.pdfAfip = ''
      this.persisteNewProvider('', this.prop, this.country)
      this.$refs.refFile.clearFiles()
      this.pFilePath = ''
      this.pFileName = ''
      this.$emit('update:pdfFilePath', '')
    },
    handleExceed (response, file, fileList) {
      this.$message.warning('Para cargar el archivo debe borrar el anterior')
    }
  },
  watch: {
    handle (val) {
      this.$emit('update:pdfFilePath', val)
    }
  },
  computed: {
    filePath () {
      this.pFilePath = this.pdfFilePath
      if (this.pFilePath !== '') {
        return this.urlUpl + this.pFilePath
      }
      return ''
    },
    fileName () {
      this.pFileName = this.pdfFileName
      return this.pFileName
    }
  }
}
</script>
<style></style>



// WEBPACK FOOTER //
// PdfFile.vue?7879ab22